export default __webpack_public_path__ + "static/media/pictogramValuable48.93c80943.svg";